<template>
  <app-modal
    model-value
    size="xs"
    data-locator="conversation-deletion-dialog"
    :cancel-text="$t('common.cancel')"
    :ok-loading="loading"
    :ok-text="$t(`${TRANSLATION_KEY_PREFIX}.confirm`)"
    @cancel="$emit('close')"
    @ok="$emit('confirm')"
  >
    <template #title>
      <span class="dialog-title">{{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}</span>
    </template>

    <template #body>
      <p class="dialog-body my-2">{{ $t(`${TRANSLATION_KEY_PREFIX}.body`) }}</p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'


const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantConversationDeletionDialog'

export default defineComponent({
  name: 'AIAssistantConversationDeletionDialog',
  emits: ['close', 'confirm'],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
})
</script>

<style scoped lang="scss">
.dialog-body {
  color: rgb(var(--v-theme-grey-darken-3));
  line-height: 20px;
}

.dialog-title {
  color: rgb(var(--v-theme-grey-darken-4));
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.15px;
}
</style>
